import { render, staticRenderFns } from "./devList.vue?vue&type=template&id=0afa60dc&scoped=true"
import script from "./devList.vue?vue&type=script&lang=ts"
export * from "./devList.vue?vue&type=script&lang=ts"
import style0 from "./devList.vue?vue&type=style&index=0&id=0afa60dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa60dc",
  null
  
)

export default component.exports